import React, {useEffect,useState} from "react";
import {IconButton, Menu, MenuItem} from "@mui/material";
import TabPageHeader from "../../header/tabpageheader";
import data from "../../../../../../layouts/dashboard/components/Projects/data";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MDBox from "../../../../../../components/MDBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import {getFields} from "../../../../../dialog/formfields";
import GenericForm from "../../../../../dialog/genericform";
import DataTableConfig from "../../../../../Tables/DataTableConfig";
import PropTypes from "prop-types";
import useConfigApi from "../../../../../utils/configapi";
import Endpoints from "../../../../../utils/endpoints";
import toast from "react-hot-toast";
import tableData from "../../../../../tabledata";

const HostConfig = ({ selectedRowData }) => {
  // const [formKey, setFormKey] = useState(0);
  const { hostConfigColumns } = tableData();
  const { hostConfigFields, hostConfigYupValidation } = getFields(); // Destructure hostConfigFields
  const [hostConfig, setHostConfig] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  // const [activeRowIndex, setActiveRowIndex] = useState(null);
  //  NEW (Fix: row mismatch issue)
  const [activeRowId, setActiveRowId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [dialogData, setDialogData] = React.useState(null);
  const [dialogMode, setDialogMode] = React.useState("edit");
  const [dialogTitle, setDialogTitle] = React.useState("Create Host Config");
  const [banks, setBanks] = useState([]);
  const [hostConfigFieldsModified, setHostConfigFieldsModified] = useState([]);
  const [formWatch, setFormWatch] = useState();
  // Store last subscription cleanup
  const [formWatchSubscription, setFormWatchSubscription] = useState();
  const api = useConfigApi();
  const [loading, setLoading] = useState(false);

  const [cardOptions, setCardOptions] = useState([]);
  const [tleKeyOptions, setTleKeyOptions] = useState([]);

  const [bankNames, setbankNames] = useState([]);
  const fetchbankNames = async () => {
    const res = await api.get("/tls/all");
    const data = res?.data || [];

    const options = data.map((item) => ({
      label: item.bankName,
      value: item.bankName,
      fullData: item, // IMPORTANT for auto-fill
    }));

    setbankNames(options);
  };

  const handleClick = () => {
    setDialogMode("create");
    setDialogData({});
    setDialogTitle("Create Host Config");
    if (cardOptions.length === 0) {
      toast.error("Card config not loaded yet");
      return;
    }

    // setFormKey((prev) => prev + 1);
    //  RESET FIELDS HERE
    // FIX: include cardOptions here
    setHostConfigFieldsModified(
      hostConfigFields.map((field) => {
        // ADDED: Card Config options
        if (field.name === "schemes") {
          return { ...field, options: cardOptions };
        }

        //  ADDED: bank dropdown
        if (field.name === "bankMasterSlNo") {
          return { ...field, options: banks, default: banks[0]?.value ?? "" };
        }

        if (field.name === "bankName") {
          return { ...field, visible: false, options: [] };
        }

        if (["hostCertificate", "clientCertificate", "clientKey"].includes(field.name)) {
          return { ...field, visible: false };
        }

        return field;
      })
    );

    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setDialogData(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setActiveRowIndex(null);
    setActiveRowId(null);
  };

  // const handleMenuOpen = (event, index) => {
  //   setAnchorEl(event.currentTarget);
  //   setActiveRowIndex(index);
  // };

  //  NEW (Fix: stable row mapping)
  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(row.slNo);
  };

  const handleActionClick = (action, item) => {
    // const row = hostConfig[activeRowIndex];
    
    const row = hostConfig.find((r) => r.slNo === activeRowId);
    if (!row) return;
    if (cardOptions.length === 0) {
      toast.error("Card config not loaded yet");
      return;
    }
    if (action === "View") {
      setModalOpen(true);
      setDialogMode("view");
      setDialogTitle("View Host Config");
      setDialogData({
        ...row,
        bankName: row.bankTLSConfig?.bankName || null,
        schemes: row.schemes ? row.schemes.split(",").map((s) => Number(s.trim())) : [],
      });

     setHostConfigFieldsModified(
       hostConfigFields.map((field) => {
         // ADDED: Card Config options
         if (field.name === "schemes") {
           return { ...field, options: cardOptions };
         }
         if (field.name === "bankMasterSlNo") {
           return { ...field, options: banks }; // 
         }

         if (field.name === "bankName") {
           return {
             ...field,
             visible: row.isTLSEnable,
             options: row.isTLSEnable ? bankNames : [],
           };
         }

         if (["hostCertificate", "clientCertificate", "clientKey"].includes(field.name)) {
           return {
             ...field,
             visible: row.isTLSEnable,
             readonly: true,
           };
         }

         return field;
       })
     );

    } else if (action === "Edit") {
      setModalOpen(true);
      setDialogMode("edit");
      setDialogTitle("Edit Host Config");
      // setDialogData(row);
      setDialogData({
        ...row,
        bankName: row.isTLSEnable ? (row.bankTLSConfig?.bankName || null) : null,
        schemes: row.schemes ? row.schemes.split(",").map((s) => Number(s.trim())) : [],
      });

      //  FIX: ALWAYS rebuild fields
      setHostConfigFieldsModified(
        hostConfigFields.map((field) => {
          // ADDED: Card Config options
          if (field.name === "schemes") {
            return { ...field, options: cardOptions };
          }

          if (field.name === "bankMasterSlNo") {
            return { ...field, options: banks }; // TLE KEY ID
          }
          if (field.name === "bankName") {
            return {
              ...field,
              visible: row.isTLSEnable,
              options: row.isTLSEnable ? bankNames : [],
            };
          }

          if (["hostCertificate", "clientCertificate", "clientKey"].includes(field.name)) {
            return {
              ...field,
              visible: row.isTLSEnable,
              readonly: true,
            };
          }

          return field;
        })
      );
    } else if (action === "Delete") {
      setModalOpen(true);
      setDialogMode("delete");
      setDialogTitle("Delete Host Config");
      setDialogData(row);
    }
    handleMenuClose();
  };

  const handleDialogSubmit = (formData) => {
    const isTLS = formData.isTLSEnable === true || formData.isTLSEnable === "true";
    if (isTLS && !formData.bankName) {
      toast.error("Please select Bank TLS Config first.");
      return false;
    }

    formData.controlConfigSerialNumber = selectedRowData.slNo;
    formData.schemes = formData.schemes
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s.length > 0)
      .map(Number);
    formData.clientCertificate
    //  NEW (Fix: ensure array format)
    //formData.schemes = Array.isArray(formData.schemes) ? formData.schemes : [];
  
    console.log("Submitted data:", formData, dialogMode);
    // Call your API here
    if (dialogMode === "create") {
      // Handle create logic here
      api
        .post(Endpoints.hostConfig.createOrUpdate, formData)
        .then((response) => {
          toast.success("Host config successfully created.");
          fetchHostConfigs(); // Fetch the latest data after creation
        })
        .catch((error) => {
          const responseMessage = error?.response?.data?.responseMessage;
          if (responseMessage.includes("Scheme is already in use")) {
            toast.error(responseMessage);
          } else {
            toast.error("Internal error occurred while creating.");
          }
        });
    } else if (dialogMode === "edit") {
      api
        .put(Endpoints.hostConfig.createOrUpdate, formData)
        .then(({ data }) => {
          toast.success("Host config successfully updated.");

          const updated = data?.data ?? formData;

          const selectedBankTLS = bankNames.find((b) => b.value === formData.bankName);
          const updatedBankTLSConfig = selectedBankTLS?.fullData ?? updated.bankTLSConfig ?? null;

          setHostConfig((prevRows) => {
            return prevRows.map((row) => {
              // Match by slNo (unique identifier) instead of index for reliability
              if (row.slNo !== updated.slNo) return row;

              const cardConfigs = updated.schemes
                ? updated.schemes.map((s) => s.configName + " | " + s.cardLabel)
                : [];
              const schemes = updated.schemes ? updated.schemes.map((s) => s.slNo).join(", ") : "";
              const bankMasterSlNo = updated.bank ? updated.bank.slNo : "";
              // Preserve existing computed cells (like `action`)
              const newRow = {
                ...row,
                ...updated,
                schemes,
                cardConfigs,
                bankMasterSlNo,
                bankTLSConfig: updatedBankTLSConfig,
                action: row.action, // Explicitly preserve action column
              };
              return newRow;
            });
          });

          closeModal(); // Close modal after successful update
        })
        .catch((error) => {
          const msg = error?.response?.data?.responseMessage;
          toast.error(
            msg
          );
        });
    }
    // } else if (dialogMode === "edit") {
    //   api.put(Endpoints.hostConfig.createOrUpdate, formData)
    //     .then((response) => {
    //       toast.success("Host config successfully updated.");
    //       fetchHostConfigs(); // Fetch the latest data after editing
    //     })
    //     .catch((error) => {
    //       const responseMessage = error?.response?.data?.responseMessage;
    //       if (responseMessage.includes("Scheme is already in use")) {
    //         toast.error(responseMessage);
    //       } else {
    //         toast.error("Internal error occurred while updating.");
    //       }
    //     });
    // }
  };

  const handleDialogDelete = (formData) => {
    if (!formData.slNo) {
      toast.error("Missing slNo for deletion.");
      return;
    }
    api
      .delete(Endpoints.hostConfig.deleteBySlNo(formData.slNo))
      .then(() => {
        toast.success(`Host config ${formData.slNo} successfully deleted.`);
        fetchHostConfigs();
      })
      .catch(() => {
        toast.error("Error deleting header config.");
      });
  };

  useEffect(() => {
    fetchHostConfigs();
    fetchCardConfigs();
    fetchbankNames(); // ADD THIS
  }, []);

  // Handler for value changes
  const handleFormWatchChange = (values, info, setValue) => {
    // ================= TLS ENABLE =================
    console.log("TLS Value:", info.values?.isTLSEnable);
    if (info.name === "isTLSEnable") {
      const isEnabled = values.isTLSEnable === true || values.isTLSEnable === "true";

      setHostConfigFieldsModified((prevFields) => {
        return prevFields.map((field) => {
          if (field.name === "bankName") {
            return {
              ...field,
              visible: isEnabled,
              options: isEnabled ? bankNames : [],
            };
          }

          if (["hostCertificate", "clientCertificate", "clientKey"].includes(field.name)) {
            return {
              ...field,
              visible: isEnabled,
              readonly: true,
            };
          }

          return field;
        });
      });

      // setHostConfigFieldsModified(updatedFields);
      if (!isEnabled) {
        setValue("bankName", null);
        setValue("hostCertificate", "");
        setValue("clientCertificate", "");
        setValue("clientKey", "");
      }
    }

    // ================= BANK SELECT =================
    if (info.name === "bankName") {
      const selectedBank = bankNames.find((b) => b.value === info.values?.bankName);

      if (selectedBank?.fullData) {
        const tls = selectedBank.fullData;
        setValue("hostCertificate", tls.hostCertificate);
        setValue("clientCertificate", tls.clientCertificate);
        setValue("clientKey", tls.clientKey);

      }
    }

    // You can add your logic here
    if (info.name === "bankMasterSlNo" && info?.values) {
      const bank = info.values?.bankMasterSlNo;
      console.log(bank);
      const bankCheck = hostConfig.filter(
        (item) => item.bankMasterSlNo === bank && item.tieKeyLoadingEnable === true
      );
      if (bankCheck.length > 0 && bankCheck[0].slNo !== info.values?.slNo) {
        setHostConfigFieldsModified(
          hostConfigFieldsModified.map((field) =>
            field.name === "tieKeyLoadingEnable"
              ? { ...field, readonly: true, default: false }
              : field
          )
        );
      } else {
        setHostConfigFieldsModified(
          hostConfigFieldsModified.map((field) =>
            field.name === "tieKeyLoadingEnable" ? { ...field, readonly: false } : field
          )
        );
      }
    }
  };

  const fetchCardConfigs = async () => {
    const banksResponse = await api.get(Endpoints.banksMaster.getAll);
    const banks = banksResponse?.data?.data || [];
    // console.log(banks);
    const cardsResponse = await api.get(
      Endpoints.cardConfig.getByControlSlNo(selectedRowData.slNo)
    );
    const cards = cardsResponse?.data?.data || [];
    const cardOptions = cards.map((card) => ({
      label: card.configName + " | " + card.cardLabel,
      value: card.slNo,
    }));
    const bankOptions = banks.map((bank) => ({
      label: bank.bankName,
      value: bank.slNo,
    }));
    setBanks(bankOptions);
    setCardOptions(cardOptions);
    setHostConfigFieldsModified(
      hostConfigFields.map((field) => {
        // Old written for bank and sl no.
        if (field.name === "schemes") {
          return { ...field, options: cardOptions };
        }
        if (field.name === "bankMasterSlNo") {
          return { ...field, options: bankOptions };
        }
        // isTLS Enable logic
        if (field.name === "bankName") {
          return { ...field, options: [], visible: false };
        }

        if (["hostCertificate", "clientCertificate", "clientKey"].includes(field.name)) {
          return { ...field, visible: false };
        }
        return field;
      })
    );
  };
  const fetchHostConfigs = () => {
    setLoading(true); // show loader at start
    api
      .get(Endpoints.hostConfig.getByControlSlNo(selectedRowData.slNo))
      .then((response) => {
        const data = response?.data.data || [];
        if (!Array.isArray(data) || data.length == 0) {
          console.log("API RESPONSE:", response);
          toast.error("No valid host configs found.");
          setHostConfig([]);
          return;
        }
        // console.log("data : ", data);
        const modifiedData = data.map((item) => {
          const action = (
            <>
              <IconButton onClick={(e) => handleMenuOpen(e, item)}>
                <MoreHorizIcon />
              </IconButton>
            </>
          );

          const cardConfigs = item.schemes
            ? item.schemes.map((s) => s.configName + " | " + s.cardLabel)
            : [];
          const schemes = item.schemes ? item.schemes.map((s) => s.slNo).join(", ") : "";
          const bankMasterSlNo = item.bank ? item.bank.slNo : "";
          return { ...item, action, schemes, bankMasterSlNo, cardConfigs };
        });
        console.log("Modified Data:", modifiedData);
        setHostConfig(modifiedData);
      })
      .catch((error) => {
        console.error("Error fetching host configs:", error);
        toast.error("Error while fetching records.");
      })
      .finally(() => {
        setLoading(false); //hide loader
      });
  };

  return (
    <>
      <MDBox
        sx={{
          px: 3,
          py: 2,
          bgcolor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TabPageHeader
          title="Host Config"
          showButton={true}
          buttonLabel="Add"
          onButtonClick={handleClick}
        />
      </MDBox>
      <MDBox
        sx={{
          px: 3,
          py: 2,
          bgcolor: "#fff",
          borderBottom: "1px solid #d3e3fd",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          overflowX: "auto",
          width: "100%",
        }}
      >
        <DataTableConfig
          table={{ columns: hostConfigColumns, rows: hostConfig }}
          showTotalEntries={true}
          isSorted={false}
          noEndBorder
          entriesPerPage={true}
          canSearch={true}
        />
      </MDBox>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
      >
        <MenuItem onClick={() => handleActionClick("View")}>
          <IconButton size="small">
            <i className="material-icons">visibility</i>
          </IconButton>
          View
        </MenuItem>
        <MenuItem onClick={() => handleActionClick("Edit")}>
          <IconButton size="small">
            <EditIcon fontSize="small" />
          </IconButton>
          Edit
        </MenuItem>
        <MenuItem onClick={() => handleActionClick("Delete")}>
          <IconButton size="small" color="error">
            <DeleteIcon fontSize="small" />
          </IconButton>
          Delete
        </MenuItem>
        {/*<MenuItem onClick={() => handleActionClick("Sync")}>*/}
        {/*    <IconButton size="small" color="error">*/}
        {/*        <RefreshIcon fontSize="small" />*/}
        {/*    </IconButton>*/}
        {/*    Sync*/}
        {/*</MenuItem>*/}
      </Menu>
      <GenericForm
        // key={formKey}
        open={isModalOpen}
        handleClose={closeModal}
        title={dialogTitle}
        fields={hostConfigFieldsModified}
        onSubmit={handleDialogSubmit}
        onDelete={handleDialogDelete}
        initialData={dialogData}
        mode={dialogMode}
        useDialog={true}
        validationSchema={hostConfigYupValidation}
        onWatchChange={handleFormWatchChange}
      />
    </>
  );
};

HostConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number,
    }),
};
export default HostConfig;
